(function () {
    'use strict'
    module.exports =changeWidth;

    function changeWidth(val) {
        let vm = this;
        vm.currentCanvas.freeDrawingBrush.width = parseInt(val, 10) || 1;
    }
})();